import SimpleFormPage from "../common/SimpleFormPage";
import { Form, Input } from "antd";
import DebounceSelect from "../common/DebounceSelect";
import axiosInstance from "../common/api";
import { useParams } from "react-router";

export default function () {
  const { id } = useParams();

  return (
    <SimpleFormPage
      title="Assegna attrezzatura"
      transformData={(form) => ({ ...form, equipment: id })}
    >
      <Form.Item label="Dipendente" name="employee">
        <DebounceSelect
          labelInValue={false}
          fetchOptions={(query) =>
            axiosInstance
              .get("employee", { params: { query, pageSize: 9999 } })
              .then(({ data }) => data.data.map((x) => ({ label: x.fullName, value: x.id })))
          }
        />
      </Form.Item>
      <Form.Item label="Note" name="notes">
        <Input />
      </Form.Item>
    </SimpleFormPage>
  );
}
